<div class="app-icon"
    (click)="toggle($event)"
    [ngClass]="!val || this.modalOpened ? 'not-checked': 'app-icon'">
    <svg-icon [src]="iconSrc"></svg-icon>
</div>
